import { LOCALE_ID, NgModule, provideZoneChangeDetection } from '@angular/core';
import { registerLocaleData }      from '@angular/common';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule }           from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import localePt from '@angular/common/locales/pt';
import 'moment/locale/pt-br';

import { ToastrModule }                       from 'ngx-toastr';
import { NgProgressbar }                      from 'ngx-progressbar';
import { provideNgProgressOptions }           from 'ngx-progressbar';
import { NgProgressHttp }                     from 'ngx-progressbar/http';
import { provideNgProgressHttp, progressInterceptor } from 'ngx-progressbar/http';
import { httpInterceptorProviders }           from '@interceptors/http-interceptor-providers';

import { LayoutModule }     from '@layout/layout.module';
import { IconsModule }      from '@shared/icons/icons.module';
import { MaterialModule }   from '@shared/material/material.module';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent }           from './app.component';
import { RedirectComponent }      from './redirect/redirect.component';
import { ReactRedirectComponent } from './react-redirect/react-redirect.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

registerLocaleData(localePt, 'pt-BR');

const progressConfig = {
  color:   '#5ed4c5',
  thick:   true,
  spinner: false
} as const;

@NgModule({
  declarations: [
    AppComponent,
    RedirectComponent,
    ReactRedirectComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgProgressbar,
    NgProgressHttp,
    ToastrModule.forRoot(),
    MaterialModule,
    IconsModule,
    LayoutModule,
    FontAwesomeModule,
  ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    httpInterceptorProviders,
    provideNgProgressOptions(progressConfig),
    provideNgProgressHttp({}),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideHttpClient(withInterceptors([progressInterceptor]), withInterceptorsFromDi()),
  ],
  bootstrap: [
    AppComponent,
  ],
})
export class AppModule {}
